import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import app from './app';
import companies from './companies';
import markets from './markets';
import customViews from './customViews';
import orders from './orders';
import user from './user';
import freightTypes from './freights';
import systemlogs from './systemlogs';
import indices from './indices';
import notifications from './notifications';

export default combineReducers({
    app,
    companies,
    markets,
    customViews,
    orders,
    user,
    freightTypes,
    systemlogs,
    indices,
    notifications,
    routing: routerReducer,
});



// WEBPACK FOOTER //
// ./source/reducers/index.js